/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOAuthApplicationCommand } from '../../models/create-o-auth-application-command';
import { CreateOAuthApplicationResult } from '../../models/create-o-auth-application-result';

export interface ApiOAuthApplicationsPost$Params {

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: CreateOAuthApplicationCommand
}

export function apiOAuthApplicationsPost(http: HttpClient, rootUrl: string, params?: ApiOAuthApplicationsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOAuthApplicationResult>> {
  const rb = new RequestBuilder(rootUrl, apiOAuthApplicationsPost.PATH, 'post');
  if (params) {
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOAuthApplicationResult>;
    })
  );
}

apiOAuthApplicationsPost.PATH = '/api/OAuthApplications';
